import { render, staticRenderFns } from "./AnPlainData.vue?vue&type=template&id=3360e20d&scoped=true&"
import script from "./AnPlainData.vue?vue&type=script&lang=js&"
export * from "./AnPlainData.vue?vue&type=script&lang=js&"
import style0 from "./AnPlainData.vue?vue&type=style&index=0&id=3360e20d&lang=scss&scoped=true&"
import style1 from "./AnPlainData.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3360e20d",
  null
  
)

export default component.exports